import { UserItem } from 'presentations/api/schema/user';
import { Provider, ProviderType } from 'domains/models/account/providerType';
import mixpanel from 'mixpanel-browser';

enum DefaultEvent {
  PageView = 'Page View',
}

export class Mixpanel {
  private static configure = () => {
    const id = process.env.NEXT_PUBLIC_MIXPANEL_TRACKING_ID;
    if (!id) return false;
    mixpanel.init(id, {
      debug: process.env.NODE_ENV === 'development',
      track_pageview: false,
      persistence: 'localStorage',
    });
    return true;
  };

  static magazinePageView = (props: {
    category: string[];
    tag: string[];
    slug: string;
    title: string;
  }) => {
    Mixpanel.track(DefaultEvent.PageView, props);
  };

  static magazineAdClick = (props: {
    position: 'inline_text' | 'sub_top';
    contentType: 'top' | 'story';
    contentId?: string;
  }) => {
    Mixpanel.track('Click Magazine Ad', props);
  };

  static signUpButtonClick = (props: { provider: Provider }) => {
    Mixpanel.track('Click Sign Up', props);
  };

  static signUp = (
    user: UserItem,
    props: {
      providerType: ProviderType;
      source: string | null;
      medium: string | null;
      campaign: string | null;
      term: string | null;
      content: string | null;
      referrer: string | null;
      landingUrl: string;
    },
  ) => {
    if (!Mixpanel.configure()) return;
    mixpanel.identify(user.uid);
    // 個人情報はセットしない
    mixpanel.people.set({
      //   $email: user.email,
      //   $name: user.name,
      ...props,
    });
    Mixpanel.track('Sign Up', props);
  };

  static login = (user: UserItem) => {
    if (!Mixpanel.configure()) return;
    mixpanel.identify(user.uid);
    Mixpanel.track('Login');
  };

  private static track = (action: string, props?: any) => {
    if (typeof window === 'undefined') return;
    if (!Mixpanel.configure()) return;
    try {
      if (action === DefaultEvent.PageView) {
        mixpanel.track_pageview(props);
      } else {
        mixpanel.track(action, props);
      }
      // console.log('Sent to mixpanel', action, props);
    } catch (error) {
      console.log(error);
    }
  };
}
